export default __webpack_public_path__ + "images/openai-white-logomark.3847781ced49be7f884f54a89bd06a8b.png";